import {
    APPTOOLBAR_RESET_APP_STATE,
    VIEWPORT_SET_DIMENSIONS,
    PROJECTS_CRUD_RESTORE_STATE,
    VIEWPORT_SCALE,
    VIEWPORT_SCALE_PIPES,
    VIEWPORT_POSITION,
    VIEWPORT_POSITION_PIPES,
    VIEWPORT_SWITCH_PANNING,
    VIEWPORT_RESET_POSITION_SCALE,
    MULTIBED_RESET_APP_STATE, APPTOOLBAR_BASIC_RESET_APP_STATE,
} from "../lib/types";

const initialState = {
    stage: null,
    scaleX: 1,
    scaleY: 1,
    positionX: 0,
    positionY: 0,
    scaleXPipes: 1,
    scaleYPipes: 1,
    isPanning: false,
    positionXPipes: 0,
    positionYPipes: 0,
    computeWidth: 200,
    computedHeight: 200,
    zoomMousePosition: null,
    zoomStagePosition: null,
};

export default ( state = initialState, action ) => {
    switch (action.type) {
        case VIEWPORT_SWITCH_PANNING:
            return {
                ...state,
                isPanning: action.payload,
            };

        case VIEWPORT_SET_DIMENSIONS:
            return {
                ...state,
                computedHeight: action.payload.height,
                computeWidth: action.payload.width,
            };

        case VIEWPORT_SCALE:
            return {
                ...state,
                scaleX: action.payload.scaleX,
                scaleY: action.payload.scaleY,
            };

        case VIEWPORT_SCALE_PIPES:
            return {
                ...state,
                scaleXPipes: action.payload.scaleX,
                scaleYPipes: action.payload.scaleY,
            };

        case VIEWPORT_POSITION:
            return {
                ...state,
                positionX: action.payload.positionX,
                positionY: action.payload.positionY,
            };

        case VIEWPORT_POSITION_PIPES:
            return {
                ...state,
                positionXPipes: action.payload.positionX,
                positionYPipes: action.payload.positionY,
            };

        case VIEWPORT_RESET_POSITION_SCALE:
            return {
                ...state,
                positionX: 0,
                positionY: 0,
                scaleX: 1,
                scaleY: 1,
            };

        case MULTIBED_RESET_APP_STATE:
            return {
                ...initialState,
                scaleX: state.scaleX,
                scaleY: state.scaleY,
                scaleXPipes: state.scaleXPipes,
                scaleYPipes: state.scaleYPipes,
                positionX: state.positionX,
                positionY: state.positionY,
                positionXPipes: state.positionXPipes,
                positionYPipes: state.positionXPipes,
                computeWidth: state.computeWidth,
                computedHeight: state.computedHeight,
                isPanning: false,
                zoomMousePosition: state.zoomMousePosition,
                zoomStagePosition: state.zoomStagePosition,
            };


        case APPTOOLBAR_BASIC_RESET_APP_STATE:
        case APPTOOLBAR_RESET_APP_STATE:
            return initialState;

        // case SUB_PROJECTS_CRUD_RESTORE_STATE:
        case PROJECTS_CRUD_RESTORE_STATE:
            let rState = action.payload.viewport;
            return {
                ...state,
                ...rState,
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/viewport-reducer.js